// extracted by mini-css-extract-plugin
module.exports = {"bgColorFrom":"#1f3756","bgColorTo":"#141539"};